import _ from 'lodash'

let listKeySearch = [
  'adress',
  'company',
  'cp',
  'email',
  'firstname',
  'job',
  'lastname',
  'member',
  'website1',
  'website2'
]

export const addTagsSearch = item => {
  // if (Array.isArray(data)) {
  //   const newData = data.map(item => {
  let tags = []
  for (var key in item) {
    if (listKeySearch.indexOf(key) !== -1) {
      if (item[key] !== '') {
        tags.push(item[key])
      }
    }
    if (key === 'skills') {
      addCategories(item[key], tags)
    }
  }
  item.tags = tags.join(' ')
  return item
  //   })
  //   return newData
  // }
}

const addCategories = (skills, tags) => {
  if (skills !== null || skills !== undefined || skills !== '') {
    let shadowCat = { ...categories }
    if (skills.split(';')[0] !== '' && skills.split(';').length > 0) {
      // console.log(skills.split(';').map(item => item.trim()))
      skills.split(';').map(skill => {
        tags.push(skill.trim())
        for (var key in shadowCat) {
          // console.log(
          //   skill.trim().toLowerCase(),
          //   '====>',
          //   shadowCat[key].toLowerCase().indexOf(skill.trim().toLowerCase())
          // )
          if (
            shadowCat[key].toLowerCase().indexOf(skill.trim().toLowerCase()) !==
            -1
          ) {
            console.log(key)
            shadowCat[key] = ''
            tags.push(key)
          }
        }
      })
    }
    // }
  }
}

const removeSkillsForGeneraliste = item => {
  if (item) {
  }
}

export const removeAccent = str => {
  var accent = [
    /[\300-\306]/g,
    /[\340-\346]/g, // A, a
    /[\310-\313]/g,
    /[\350-\353]/g, // E, e
    /[\314-\317]/g,
    /[\354-\357]/g, // I, i
    /[\322-\330]/g,
    /[\362-\370]/g, // O, o
    /[\331-\334]/g,
    /[\371-\374]/g, // U, u
    /[\321]/g,
    /[\361]/g, // N, n
    /[\307]/g,
    /[\347]/g // C, c
  ]
  var noaccent = [
    'A',
    'a',
    'E',
    'e',
    'I',
    'i',
    'O',
    'o',
    'U',
    'u',
    'N',
    'n',
    'C',
    'c'
  ]

  for (var i = 0; i < accent.length; i++) {
    str = str.replace(accent[i], noaccent[i])
  }
  // console.log(str)

  return str
}

export const categoriesArray = () => {
  let newCat = {}
  let newArr = []
  for (var keys in categories) {
    if (categories.hasOwnProperty(keys)) {
      newCat[keys] = categories[keys].split(';')
    }
  }
  _.mapKeys(newCat, (item, key) => {
    newArr.push([key, item])
  })
  return newArr
}

export const categories = {
  Généraliste: '',
  'Politiques agricoles':
    'PAC;OMC;Accords de libre-échange;Politique agricole française;Politiques agricoles internationales',
  'Productions végétales':
    'Grandes cultures;Fruits et légumes;Viticulture - vin;Horticulture - jardin',
  'Productions animales':
    'Lait;Bovins viande;Porc;Ovins - caprins;Equin;Volaille - œuf - lapin',
  Agrofourniture:
    'Engrais;Phytosanitaires et biocontrôle;Alimentation animale;Santé animale - vétérinaire;Machinisme agricole – Agroéquipement;Semences',
  Environnement: 'Environnement;Bio;Climat',
  Société: 'Santé des agriculteurs;Bien-être animal',
  'Institutions et organisations professionnelles des agriculteurs':
    'Syndicats;Coopératives;Chambres d’agriculture;Institutions publiques et politiques;Instituts techniques',
  Commerce: 'Marchés agricoles;Echanges internationaux',
  Recherche:
    'OGM;Biotechnologie;Non-alimentaire;Biocarburants;Robotisation;Big data - numérique',
  Agroalimentaire:
    'Transformation;Distribution;Consommation;Signes de qualité;Financement',
  'Bois-forêt': 'Bois-forêt',
  Ruralité: 'Ruralité - Aménagement du territoire',
  'Enseignement agricole': 'Enseignement agricole',
  Exploitations:
    'Foncier;Structure des exploitations;Installation - transmission;Agriculture sociétaire (GAEC, EARL, SA, etc);Financement - Assurances;Diversification (Circuit courtn, énergie, tourisme, etc);Fiscalité et social - Réglementations',
  Communication: 'Communication agricole'
}

export const searchCategories = {
  Généraliste: '',
  'Politiques agricoles': 'PAC;Accords de libre-échange',
  'Productions végétales':
    'Grandes cultures;Fruits et légumes;Viticulture;Horticulture',
  'Productions animales': 'Lait;viande;œuf',
  Agrofourniture:
    'Semences;Phytosanitaires et biocontrôle;Engrais;Machinisme;Agroéquipement;Alimentation animale',
  Environnement: 'Climat;Bio…',
  Société: 'Santé des agriculteurs;Bien-être animal',
  'Institutions et organisations professionnelles des agriculteurs':
    'Syndicats;Coopératives;Chambres d’agriculture...',
  Commerce: 'Marchés agricoles;Echanges internationaux',
  Recherche: 'Biotechnologie;OGM;Biocarburants;Robotisation;Big data…',
  Agroalimentaire: 'Transformation;Distribution;Consommation',
  'Bois-forêt': '',
  Ruralité: 'Aménagement du territoire',
  'Enseignement agricole': '',
  Exploitations: 'Foncier;Structure;Installation;Financement;Assurances',
  Communication: ''
}



// WEBPACK FOOTER //
// ./src/func/skills.js